const internalSiteGiftCard = (state = false, action) => {
    switch(action.type) {
        case 'internalSiteGiftCard':
            return action.payload;
        default:
            return state;
    }
}

export default internalSiteGiftCard;